// @ts-nocheck
import { getBit } from "../helpers/binary-helpers.js";
import { SimpleByteRegister } from "../helpers/simple-byte-register.js";
export class LcdControlRegister extends SimpleByteRegister {
    // MultiNostalgia patch: dropped redundant `offset = 0xff40` field
    // initializer. The base SimpleByteRegister already sets `offset`
    // from its constructor arg (and the only caller in gpu.ts passes
    // 0xff40 explicitly: `new LcdControlRegister(0xff40)`). The field
    // initializer was a no-op upstream and tripped TS strict mode's
    // override-check.
    get isBackgroundDisplayOn() {
        return getBit(this.value, 0) === 1;
    }
    get isObjOn() {
        return getBit(this.value, 1) === 1;
    }
    get objectHeight() {
        const objectBlockCompositionFlag = getBit(this.value, 2);
        return objectBlockCompositionFlag === 0 ? 8 : 16;
    }
    get backgroundCodeArea() {
        return getBit(this.value, 3);
    }
    get backgroundCharacterData() {
        return getBit(this.value, 4);
    }
    get windowCharacterData() {
        return this.backgroundCharacterData;
    }
    get isWindowingOn() {
        return getBit(this.value, 5) === 1;
    }
    get windowCodeArea() {
        return getBit(this.value, 6);
    }
    get windowTileMapStartAddress() {
        return this.windowCodeArea === 0 ? 0x1800 : 0x1C00;
    }
    get backgroundTileMapStartAddress() {
        return this.backgroundCodeArea === 0 ? 0x1800 : 0x1C00;
    }
    get backgroundCharacterDataStartAddress() {
        return this.backgroundCharacterData === 0 ? 0x0800 : 0x0000;
    }
    get isLCDControllerOperating() {
        return getBit(this.value, 7) === 1;
    }
}
//# sourceMappingURL=lcd-control-register.js.map